import { Guid } from "@/Common/Models/Guid";
import { IPharmacyOrderMedicationDosageDto } from "../Api/Dto/IPharmacyOrderMedicationDosageDto";

export class PharmacyOrderMedicationDosageModel {
    public id: Guid;
    public pharmacyOrderMedicationId: Guid;
    public doseString: string | null;
    public unit: number | null;
    public typeLookupId: Guid | null;
    public duration: number | null;
    public frequency: string | null;
    public servedQuantity: string | null;
    public isQuantityMode: boolean | null;
    public rankPosition: number | null;

    public constructor(init?: Partial<PharmacyOrderMedicationDosageModel>) {
        Object.assign(this, init);
    }

    public static fromResponseModel(model: IPharmacyOrderMedicationDosageDto): PharmacyOrderMedicationDosageModel {
        return new PharmacyOrderMedicationDosageModel({
            id: model.Id,
            pharmacyOrderMedicationId: model.PharmacyOrderMedicationId,
            doseString: model.DoseString,
            unit: model.Unit,
            typeLookupId: model.TypeLookupId,
            duration: model.Duration,
            frequency: model.Frequency,
            servedQuantity: model.ServedQuantity,
            isQuantityMode: model.IsQuantityMode,
            rankPosition: model.RankPosition
        });
    }
}
